"use client";

import cn from "@core/utils/class-names";
import TagIcon from "@core/components/icons/tag";
import MetricCard from "@core/components/cards/metric-card";
import UserAvatarIcon from "@core/components/icons/user-avatar";
import { pendingKYC } from "../../../data/pending-kyc";
import { User } from "packages/app/src/types";
import { useEffect, useState } from "react";

interface AllUsersTableProps {
  users: User[];
  isLoading: boolean;
  error: Error | null;
  className?: string;
}

export default function UserMetricCards({
  users,
  isLoading,
  error,
  className,
}: AllUsersTableProps) {
  const [pendingKYC, setPendingKYC] = useState<number>();

  function countKycFailures(users: User[]): { false: number; Failed: number } {
    let falseCount = 0;
    let failedCount = 0;

    for (const u of users) {
      if (u.kycVerified === "false") {
        falseCount++;
      } else if (u.kycVerified === "Failed") {
        failedCount++;
      }
    }

    return { false: falseCount, Failed: failedCount };
  }

  useEffect(() => {
    const allPendingKYC = countKycFailures(users);
    setPendingKYC(allPendingKYC.Failed + allPendingKYC.false);
  }, [users]);
  const MatricStat = [
    {
      id: 1,
      icon: <UserAvatarIcon className="h-full w-[80%]" />,
      title: "All User",
      metric: users.length,
    },
    {
      id: 2,
      icon: <TagIcon className="h-full w-full" />,
      title: "Pending KYC",
      metric: pendingKYC,
      link: "/user-management/kyc",
    },
  ];
  return (
    <div
      className={cn("grid grid-cols-1 gap-5 3xl:gap-8 4xl:gap-9", className)}
    >
      {MatricStat.map((stat) => (
        <MetricCard
          key={stat.title + stat.id}
          title={stat.title}
          metric={stat.metric}
          icon={stat.icon}
          // link={stat.link}
          iconClassName="bg-transparent w-11 h-11"
        />
      ))}
    </div>
  );
}
